<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input :value="title" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>内容</span>
				<editor v-model="content" :enableEditor="false"></editor>
			</div>
		</div>
	</Popup>
</template>

<script>
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			types: {
				type: Array,
				default() { return []; }
			},
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				selfDisplay: false,
				
				title: '',
				content: ''
			}
		},
		methods: {
			
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.title = this.obj.title;
					this.content = this.obj.content;
				}
			}
		}
	}
</script>

<style>
</style>
